module.exports = __webpack_public_path__ + "img/23.4cffab37.jpg";